module.exports = __webpack_public_path__ + "media/metronic/_theme/media/error/bg3-245be9ae0884109625e742093701566d.jpg";